import script from "./PreviewCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./PreviewCard.vue?vue&type=script&setup=true&lang=ts"

import "./PreviewCard.vue?vue&type=style&index=0&id=7030084b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7030084b"]])

export default __exports__